/* eslint-disable prettier/prettier */
/* eslint-disable import/order */
import { ConfirmActionMenuItem } from '@bvi/common-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface IRemoveActionProperties {
  onClick: () => void;
}

export const RemoveAction: FC<IRemoveActionProperties> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <ConfirmActionMenuItem
      question={t('manageList.actions.remove.question')}
      confirm={t('dialog.confirm')}
      cancel={t('dialog.cancel')}
      onClick={onClick}
    >
      {t('manageList.actions.remove.caption')}
    </ConfirmActionMenuItem>
  );
};
